
export default {
    name: 'CustomCheckboxGroup',
    props: {
        value: {
            type: Array,
            default: () => []
        },
        options: {
            type: Array,
            default: () => []
        },
        valueType: {
            type: String,
            default: 'value'
        }
    },
    computed: {
        modelValue: {
            get() {
                return this.value || []
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        handleSelect(key) {
            const currentValues = [...this.modelValue]
            const index = currentValues.indexOf(key)

            if (index > -1) {
                currentValues.splice(index, 1)
            } else {
                currentValues.push(key)
            }

            this.modelValue = currentValues
        }
    }
}
